import React, { useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { setBackdropLoadingAction } from 'store/actions/mainPage';
import { getText } from 'services/languageService';
import { ExportModal } from 'components/UI/ExportModal';
import { TooltipMapIcon } from 'components/UI/TooltipMapIcon';
import { MapElementIcon } from 'components/UI/MapElementIcon';
import { getAllChildren } from 'components/LayersTab/constants';
import {
  exportDataLog,
  exportMap,
  exportMapFile,
  exportMapXLSX,
} from 'utils/exportFile';
import { Box, IconButton, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

export const ExportElement: React.FC = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const {
    isLogged,
    currentAteVC,
    currentAteRegions,
    currentAteCities,
    currentTab,
  } = useAppSelector((state) => state.mainPage);
  const titleRef = useRef(null);
  const {
    currentLayerId,
    allChildren,
    currentLayerParent,
    allLayers,
    currenMapFileUrl,
    currAteRegion,
    currAteCity,
    currAteVC,
  } = useAppSelector((state) => state.layers);

  const toggleOpen = () => {
    setOpen(!open);
  };
  const layer = allChildren.find((item) => item.id === currentLayerId);
  const fileTitle = layer
    ? `${currentLayerParent} (${layer.name})`
    : getText('MAP_NAME');

  const hasLayer = currentLayerParent || layer?.name;
  const ate = {};

  // for add single ate
  [currAteRegion, currAteCity, currAteVC].forEach((item, index) => {
    if (item && !Array.isArray(item) && item.id) {
      ate[`ate_${++index}[0]`] = `${item.id}_${item.type}`;
    }
  });

  // for add multiple ate
  [currentAteRegions, currentAteCities, currentAteVC].forEach(
    (ateItem, ateIndex) =>
      ateItem.forEach(({ id, type }, _index) => {
        if (id !== 'all') {
          ate[`ate_${ateIndex + 1}[${_index}]`] = `${id}_${type}`;
        }
      })
  );

  const _exportMapFile = () => {
    dispatch(setBackdropLoadingAction(true));
    exportMapFile(currenMapFileUrl!)
      .then(() => {
        return exportDataLog(isLogged, fileTitle, 'pdf', 'fullmap');
      })
      .finally(() => {
        dispatch(setBackdropLoadingAction(false));
        setOpen(false);
      });
  };

  const onExport = (ext: string) => {
    const mapRef = document.getElementById('map-ref');
    const legendRef = document.getElementById('legend-ref');
    dispatch(setBackdropLoadingAction(true));

    if (ext === 'xlsx') {
      exportMapXLSX(isLogged, String(layer?.id), fileTitle, ate, currentTab)
        .then(() => exportDataLog(isLogged, fileTitle, ext, 'map'))
        .finally(() => {
          dispatch(setBackdropLoadingAction(false));
          setOpen(false);
        });
    } else {
      // @ts-ignore
      exportMap(mapRef, legendRef, titleRef.current, fileTitle, ext, hasLayer)
        .then(() => exportDataLog(isLogged, fileTitle, ext, 'map'))
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          dispatch(setBackdropLoadingAction(false));
          setOpen(false);
        });
    }
  };

  let isAvailableLayer = false;
  const notAvailExportGroup: any = allLayers.find((item) => item.tree_id === 5);

  if (notAvailExportGroup) {
    const notAvailLayers = getAllChildren(notAvailExportGroup.children).map(
      (item) => item.id
    );

    isAvailableLayer = !notAvailLayers.includes(currentLayerId);
  }

  const availableExt =
    layer && isAvailableLayer ? ['pdf', 'png', 'xlsx'] : ['pdf', 'png'];

  return (
    <Box sx={{ position: 'relative' }}>
      <TooltipMapIcon title={getText('EXPORT_MAP_TITLE')}>
        <MapElementIcon>
          <IconButton onClick={toggleOpen}>
            <DownloadIcon />
          </IconButton>
        </MapElementIcon>
      </TooltipMapIcon>
      <Box
        sx={{
          position: 'absolute',
          right: 50,
          top: !!currenMapFileUrl ? -100 : -40,
          backgroundColor: 'white',
          zIndex: 1000,

          svg: {
            fill: 'inherit',
            fontSize: '1em',
          },
        }}
      >
        <ExportModal
          open={open}
          handleClose={toggleOpen}
          exportCb={onExport}
          exportMapFile={_exportMapFile}
          title={getText('EXPORT_MAP_TITLE')}
          ext={availableExt}
          hasMapFile={!!currenMapFileUrl}
        />
      </Box>
      <Box
        ref={titleRef}
        sx={{
          position: 'fixed',
          top: '-9999px',
          width: 'calc(100vw - 450px)',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Typography sx={{ fontSize: '18px' }}>{fileTitle}</Typography>
      </Box>
    </Box>
  );
};
